import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';
import type { Candidate } from '@core/viewbox-candidates-data';

const namespace = 'viewboxNotes';

export const ViewboxNotesActions = createActions(namespace, {
  delete: ngrxEvent<number>(),
  deleteSuccess: ngrxEvent<{ note: Candidate.Note }>(),
  deleteFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  save: ngrxEvent<{
    candidateId: number | null;
    data: Partial<Candidate.Note>;
  }>(),
  saveSuccess: ngrxEvent<{ note: Candidate.Note }>(),
  saveFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
